// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import App from './App.vue'
import VueQriously from 'vue-qriously'
import router from '../router'
import VueI18n from 'vue-i18n'

// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// export default vConsole
const title = Vue.directive('title', {
  inserted: function (el) {
    document.title = el.getAttribute('title')
  }
})
Vue.use(VueQriously)
Vue.use(MintUI)
Vue.use(VueI18n)
/* eslint-disable no-new */
const i18n = new VueI18n({
  locale: 'zh',
  messages: {
    zh: require('./common/i18n/app-zh.json'),
    th: require('./common/i18n/app-th.json'),
    en: require('./common/i18n/app-en.json')
  }
})
new Vue({
  el: '#app',
  components: {
    App
  },
  router,
  i18n,
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js